import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ads-dropdown-button',
  templateUrl: './dropdown-button.component.html'
})
export class DropdownButtonComponent implements OnInit {
  @Input("data") data: Array<any> = [];
  @Input("disabled") disabled: boolean = false;
  @Input("text") text: string = "";
  @Input("selectedvalue") selectedvalue: string = "";
  @Input("buttonStaticCssclass") buttonStaticCssclass: string = "";
  @Input("optionsStaticCssclass") optionsStaticCssclass: string = "";
  @Input("buttonBindingCssclass") buttonBindingCssclass: string = "";
  @Input("optionsBindingCssclass") optionsBindingCssclass: string = "";
  @Input("buttonStyle") buttonStyle: string;
  @Input("optionsStyle") optionsStyle: string;
  @Input("valuefield") valuefield: string = "";
  @Input("textfield") textfield: string = "";
  @Input("height") height: string = '';
  @Input("width") width: string = '';
  @Input("position") position: string = '';
  @Input("btnvariation") btnvariation: string = '';
  @Input("splitButton") splitButton: boolean = false;
  @Input("fileType") fileType: string = '';
  @Output("itemChange") itemChange: EventEmitter<any> = new EventEmitter<any>();
  @Output("selectedvalueChange") selectedvalueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output("splitButtonClick") splitButtonClick: EventEmitter<any> = new EventEmitter<any>();
  ngOnInit(): void {
  }
  dropdownitemClick(item) {
    if (this.iscomplex) {
      this.selectedvalue = item[this.textfield];
    }
    else {
      this.selectedvalue = item;
    }
    this.selectedvalueChange.emit(this.selectedvalue);
    this.itemChange.emit(item);
  }
  buttonClick(e) {
    this.splitButtonClick.emit(e)
  }
  public get iscomplex(): boolean {
    return this.textfield != "";
  }

}
